import moment from "moment"

// Allow up to 24 hours before stepping up to "a day ago", matching the design's "23 hours ago".
moment.relativeTimeThreshold("h", 24)
// Step up from days to weeks after 7 days
moment.relativeTimeThreshold("d", 7)
// Step up from weeks to months after 4 weeks
moment.relativeTimeThreshold("w", 4)

/**
 * Parses a calendar date such as "1955-01-01" into local time.
 */
export const parseIsoDate = (value: string): Date | null => {
  const m = moment(value.trim(), "YYYY-MM-DD", true)
  return m.isValid() ? m.toDate() : null
}

/** Formats a date into a localized long format (e.g. "July 3, 1945"). */
export const formatDate = (date: Date, locale: string): string =>
  moment(date).locale(locale).format("LL")

/** Formats the relative elapsed time between an instant and a reference date (e.g. "23 hours ago"). */
export const formatRelative = (
  instant: Date,
  now: Date,
  locale: string
): string => moment(instant).locale(locale).from(now)
